module.exports = __webpack_public_path__ + "img/en_payments_guide.68cee98f.jpg";